import {useEffect, useState} from 'react'
import {useSearchParams} from 'react-router-dom'

const useAddCreditCard = () => {
    const [ccResponse, setCcResponse] = useState(null)
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        const cc = searchParams?.get('cc')
        const ccd = searchParams?.get('ccd')
        let ccRes = null
        if (cc === 'fail') {
            ccRes = 'הוספת כרטיס האשראי נכשלה'
            if (ccd) {
                ccRes = `הוספת כרטיס אשראי ${ccd} נכשלה`
            }
        } else if (cc === 'success') {
            ccRes = 'הוספת כרטיס האשראי בוצעה בהצלחה'
            if (ccd) {
                ccRes = `הוספת כרטיס אשראי ${ccd} בוצעה בהצלחה`
            }
        }
        setSearchParams({})
        setCcResponse(ccRes)
    }, [ccResponse, searchParams, setSearchParams])

    useEffect(() => {
        if (ccResponse) {
            alert(ccResponse)
        }
    }, [ccResponse])

    return ccResponse
}

export default useAddCreditCard
